// extracted by mini-css-extract-plugin
module.exports = {"serviceWrapper":"serviceWrapper-bdJnN","button":"button-VxBVr"};